// TODO new upcoming code
import React, {
	useEffect,
	useLayoutEffect,
	useMemo,
	useRef,
	useState,
} from 'react';
import useAuthenticatedUsers from '../../hooks/useAuthenticatedUsers';
import { useNavigate, useParams } from 'react-router-dom';
import moment from 'moment-timezone';
import liveIcon from '../../assets/new-icons/course-live-dark-icon.svg';
import durationIcon from '../../assets/new-icons/course-duration-dark-icon.svg';
import languageIcon from '../../assets/new-icons/course-language-dark-icon.svg';
import calenderIcon from '../../assets/new-icons/course-calender-dark-icon.svg';
import { ReactComponent as CLose } from '../../assets/close_blue.svg';
import { ReactComponent as Support } from '../../assets/new-icons/whatsapp-icon.svg';
import { ReactComponent as Mute } from '../../assets/mute.svg';
import { ReactComponent as UnMute } from '../../assets/unmute.svg';
import whatsappBar from '../../assets/whatsapp-bottom-sticker.png';
import eventTicketIcon from '../../assets/new-icons/event-ticket-icon.png';
import watchIntro from '../../assets/new-icons/watch_intro.svg';

import {
	checkUserExistOrNot,
	enrolUserToLiveEvent,
	getLiveEvents,
	getUserByUserId,
	loginInternationalUsers,
	signUpUser,
} from '../../services/Firebase';

import './UpcomingCourseDescriptionPage.css';
import {
	generateUniqueId,
	isEmpty,
	eventsTabs,
	mediaEndpoint,
} from '../../utils/utils';
import { Mixpanel } from '../../analytics/Mixpanel';
import Button from '../../components/button/Button';
import 'react-lazy-load-image-component/src/effects/blur.css';
import { toast } from 'react-toastify';
import Loader from '../../components/loader/Loader';
import { COLORS } from '../../utils/colors';
import { useDispatch, useSelector } from 'react-redux';
import { FaqsCourse } from '../../utils/utils';
import FAQ from '../plans/components/FAQ';
import { ReactComponent as PaymentSuccess } from '../../assets/payment-success.svg';
import { setForceRefreshOnCoursePurchase } from '../../store/features/UpcomingClassesSlice';
import CourseRegistraionForm from './components/CourseRegistraionForm';
import BackButton from '../../components-v2/buttons/BackButton';
import { events, events_action, events_page } from '../../analytics/Events';
import { addUsers } from '../../store/features/AuthSlice';
import Shimmer from '../../components-v2/shimmer/Shimmer';
import PrimaryButton from '../../components-v2/buttons/PrimaryButton';
import useVisibilityObserver from '../../hooks/useVisibilityObserver';
import KnowYourInstructor from '../instructor/KnowYourInstructor';
import GreyAppLayout from '../GreyAppLayout';

import { Swiper, SwiperRef, SwiperSlide } from 'swiper/react';
import { FreeMode } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/free-mode';
import '../../screens/plans/components/PlanDescriptionPage.css';
import CourseBenefits from './components/CourseBenefits';
import CourseWhatYouGetItem from './components/CourseWhatYouGetItem';
import { isIOS } from 'react-device-detect';
import bullet from '../../assets/new-icons/tick-bullet.png';
import EventCheckoutPage from './components/EventCheckoutPage';

declare const window: any;

interface TriggeredEvents {
	[key: string]: boolean;
}

const sectionRanges = {
	section1: { start: 0, end: 200, section_heading: 'Event landing top video' },
	section2: { start: 0, end: 500, section_heading: 'About' },
	section3: { start: 200, end: 800, section_heading: 'What you get' },
	section4: {
		start: 400,
		end: 900,
		section_heading: 'Why to join',
	},
	section5: {
		start: 600,
		end: 1000,
		section_heading: 'Ideal for',
	},
	section7: {
		start: 800,
		end: 1400,
		section_heading: 'Know your Instructors',
	},
	section8: { start: 800, end: 1600, section_heading: 'FAQs' },
	// Add other sections as needed
} as { [key: string]: { start: number; end: number; section_heading: string } };

export enum STATES {
	LOADING,
	COURSE_DESCRIPTION_PAGE,
	COURSE_CHECKOUT_PAGE,
	COURSE_SIGNUP_FORM,
	COURSE_OTP_FORM,
	PAYMENT_SUCCESS_PAGE,
	PAYMENT_FAILURE_PAGE,
}

const UpcomingEventDescriptionPage = () => {
	const navigate = useNavigate();

	const [calendarItem, setCalendarItem] = useState<any>(null);
	const [recordingStatus, setRecordingStatus] = useState<boolean>(false);
	const [muted, setMuted] = useState(false);
	const plan_experiment_key = useSelector(
		(state: any) => state.abExperiment.data.plan_experiment_key
	);
	const onboarding_experiment_key = useSelector(
		(state: any) => state.abExperiment.data.onboarding_experiment_key
	);
	const subscription_experiment_key = useSelector(
		(state: any) => state.abExperiment.data.subscription_experiment_key
	);

	const { eventId } = useParams();

	const user = useSelector((state: any) => state?.auth?.user?.data);
	const userData = useAuthenticatedUsers(true);
	const [loader, setLoader] = useState(false);
	const [state, setState] = useState<STATES>(STATES.COURSE_DESCRIPTION_PAGE);

	const daysToExpire = useSelector(
		(state: any) => state.plan?.userPlan?.daysToExpire
	);

	const formattedDateTime = useMemo(() => {
		if (calendarItem && calendarItem.date) {
			const { _seconds, _nanoseconds } = calendarItem.date;

			return moment(new Date(_seconds * 1000 + _nanoseconds / 1000000)).format(
				'DD MMM YY, h:mm A'
			);
		}
		return null;
	}, [calendarItem]);

	const currentDateMoment = moment();

	const [imageUrl, setImageUrl] = useState('');
	const [videoUrl, setVideoUrl] = useState('');

	const [selectedTab, setSelectedTab] = useState(0);

	const [selectedFAQIndex, setSelectedFAQIndex] = useState<number | null>();
	const [appliedKarmaPoints, setAppliedKarmaPoints] = useState(0);
	const dispatch = useDispatch();

	const [error, setError] = useState('');

	const [videoLoaded, setVideoLoaded] = useState(false);
	const [isPlayingTopVideo, setIsPlayingTopVideo] = useState(false);
	const [isVideoPlayedOnce, setIsVideoPlayedOnce] = useState(false);

	const courseSliderRef = useRef<HTMLDivElement>(null);
	const tabRefs = useRef(
		[...Array(eventsTabs.length)].map(() => React.createRef<HTMLDivElement>())
	);

	const [triggeredEvents, setTriggeredEvents] = useState<TriggeredEvents>({
		section1: false,
		section2: false,
		section3: false,
		section4: false,
		section5: false,
		section6: false,
		section7: false,
		section8: false,
		section9: false,
		section10: false,
		section11: false,
		section12: false,
		section13: false,
	});

	const supportRef = useRef<any>();
	const [whatsappRef, isVisible] = useVisibilityObserver({
		topOffset: 0,
		bottomOffset: 0,
	});

	const [lightRef, isLightVisible] = useVisibilityObserver({
		topOffset: 0,
		bottomOffset: 40,
	});

	const swiperRef = useRef<SwiperRef>(null);

	const [name, setName] = useState('');
	const [detailsPhone, setDetailsPhone] = useState('');

	useLayoutEffect(() => {
		if (supportRef.current) {
			if (isVisible) {
				supportRef.current!.style.display = 'none';
			} else {
				supportRef.current!.style.display = 'initial';
			}
		}
	}, [isVisible]);

	useEffect(() => {
		let isScrolling: NodeJS.Timeout;
		window.onscroll = () => {
			clearTimeout(isScrolling);
			if (courseSliderRef.current && lightRef.current) {
				if (lightRef.current.getBoundingClientRect().top <= 50) {
					if (courseSliderRef.current.style.position !== 'fixed') {
						courseSliderRef.current.style.position = 'fixed';
						courseSliderRef.current.style.top =
							calendarItem?.comment &&
							!currentDateMoment.isAfter(formattedDateTime)
								? '90px'
								: '50px';
						courseSliderRef.current.style.boxShadow =
							'1px 2px 12px 0px rgba(17, 24, 39, 0.1)';
					}
				} else {
					if (courseSliderRef.current.style.position !== 'absolute') {
						courseSliderRef.current.style.position = 'absolute';
						courseSliderRef.current.style.top = '0';
						courseSliderRef.current.style.boxShadow = 'none';
					}
				}
			}

			isScrolling = setTimeout(() => {
				tabRefs.current.forEach((tabRef, index) => {
					if (index === 0) {
						if (
							tabRef.current &&
							swiperRef.current &&
							tabRef.current.getBoundingClientRect().top <= 2000
						) {
							setSelectedTab(index);
							swiperRef.current?.swiper.slideTo(index);
						}
					} else if (index === eventsTabs.length - 1) {
						if (
							tabRef.current &&
							swiperRef.current &&
							tabRef.current.getBoundingClientRect().top <= 1000
						) {
							setSelectedTab(index);
							swiperRef.current?.swiper.slideTo(index);
						}
					} else {
						if (
							tabRef.current &&
							swiperRef.current &&
							tabRef.current.getBoundingClientRect().top <= 100
						) {
							setSelectedTab(index);
							swiperRef.current?.swiper.slideTo(index);
						}
					}
				});
			}, 150);
		};

		document.body.style.overscrollBehavior = 'none';
		return () => {
			document.body.style.overscrollBehavior = 'none';
		};
	}, [lightRef, courseSliderRef]);

	const markMixPanelEvent = (
		position: number,
		ranges: {
			[key: string]: { start: number; end: number; section_heading: string };
		}
	) => {
		const checkAndTriggerEvent = (
			sectionKey: string,
			start: number,
			end: number
		) => {
			if (
				!triggeredEvents[sectionKey] &&
				position >= start - 10 &&
				position <= end + 10
			) {
				if (ranges[sectionKey].section_heading === 'Know your instructor') {
					Mixpanel.track('view_event_landing_page_section', {
						event_action: 'viewed',
						section_heading: ranges[sectionKey].section_heading,
						event_page: events_page.event_landing_page,
						instructor_name: calendarItem?.instructors[0].name,
						event_name: calendarItem?.title,
						event_start_date: calendarItem?.display_date,
					});
				} else {
					Mixpanel.track('view_event_landing_page_section', {
						event_action: 'viewed',
						section_heading: ranges[sectionKey].section_heading,
						event_page: events_page.event_landing_page,
						event_name: calendarItem?.title,
						event_start_date: calendarItem?.display_date,
					});
				}

				setTriggeredEvents((prevEvents: any) => ({
					...prevEvents,
					[sectionKey]: true,
				}));
			}
		};

		Object.entries(ranges).forEach(([sectionKey, { start, end }]) => {
			checkAndTriggerEvent(sectionKey, start, end);
		});
	};

	useEffect(() => {
		const handleScroll = () => {
			markMixPanelEvent(window.scrollY, sectionRanges);
			if (window.scrollY > 280) {
				setIsPlayingTopVideo(false);
			}
		};
		window.addEventListener('scroll', handleScroll);
		return () => {
			window.removeEventListener('scroll', handleScroll);
		};
	}, [triggeredEvents]);

	useEffect(() => {
		if (isEmpty(user) && userData?.uid) {
			getUserByUserId(userData?.uid).then((userLoginResult) => {
				dispatch(addUsers(userLoginResult?.userData));
				Mixpanel.identify(userData?.uid);
			});
		}
	}, [dispatch, user, userData]);

	useEffect(() => {
		if (calendarItem) {
			Mixpanel.track('view_event_landing_page', {
				event_action: 'viewed',
				event_name: calendarItem?.title,
				event_date: calendarItem?.display_date,
				instructor_name: calendarItem?.instructors[0].name,
				event_page: events_page.event_landing_page,
				type: calendarItem?.title,
			});
		}
	}, [calendarItem]);

	useEffect(() => {
		if (calendarItem === null && eventId) {
			setLoader(true);
			getLiveEvents(userData?.uid)
				.then((result: any) => {
					console.log(result.data.find((item: any) => item.id === eventId));
					setCalendarItem(result.data.find((item: any) => item.id === eventId));
					setLoader(false);
				})
				.catch((err: any) => {
					console.error(err);
					setLoader(false);
				});
		}
	}, [calendarItem, eventId, userData?.uid]);

	useEffect(() => {
		if (calendarItem?.video_url) {
			const videoUrl = mediaEndpoint + calendarItem?.video_url;
			setVideoUrl(videoUrl);
		}

		if (calendarItem?.thumbnail_l2) {
			const imageUrl = mediaEndpoint + calendarItem?.thumbnail_l2;
			setImageUrl(imageUrl);
		}
	}, [calendarItem]);

	function loadScript(src: any) {
		return new Promise((resolve) => {
			const script = document.createElement('script');
			script.src = src;
			script.onload = () => {
				resolve(true);
			};
			script.onerror = () => {
				resolve(false);
			};
			document.body.appendChild(script);
		});
	}

	async function payNowClickHandler(
		price: string,
		applied_karma_points: number,
		recordings_status: boolean
	) {
		setAppliedKarmaPoints(applied_karma_points);
		setRecordingStatus(recordings_status);
		if (state === STATES.PAYMENT_FAILURE_PAGE) {
			Mixpanel.track('click_retry_event_payment', {
				event_action: 'clicked',
			});
			setState(STATES.COURSE_CHECKOUT_PAGE);
		}

		const res = await loadScript(
			'https://checkout.razorpay.com/v1/checkout.js'
		);

		if (!res) {
			toast.error(`Razorpay SDK failed to load. Are you online?`, {
				position: toast.POSITION.TOP_CENTER,
				autoClose: 2000,
				hideProgressBar: true,
			});
			return;
		}
		// TODO change it
		const parsedPrice = parseFloat(price);
		// const parsedPrice = 1;

		const docId = generateUniqueId(
			user?.uid || userData?.uid,
			calendarItem?.id,
			String(Date.now())
		);

		enrolUserToLiveEvent(
			user?.uid || userData?.uid,
			calendarItem?.id,
			'',
			'',
			'',
			parsedPrice,
			appliedKarmaPoints,
			daysToExpire && daysToExpire > 0,
			docId,
			calendarItem?.free_for_all
		).then((result: any) => {
			console.log('enrolUserToLiveEvent', result);
		});

		const options = {
			key: 'rzp_live_kAJsHAyh9zWVtC',
			amount: parsedPrice * 100,
			currency: calendarItem?.currency === '₹' ? 'INR' : 'USD',
			name: calendarItem?.title + ' - Seek',
			description: `Event Enrolment Fee - ${docId}`,
			image:
				'https://firebasestorage.googleapis.com/v0/b/seek-c3955.appspot.com/o/seek-logo-icon-blue.png?alt=media&token=e73fb5ae-3f19-42d0-afe8-1b76a89cf66f',
			handler: async function (response: any) {
				if (response.razorpay_payment_id) {
					navigate('/event/payment-successful', {
						state: { course: calendarItem },
					});
					dispatch(setForceRefreshOnCoursePurchase(true));
					try {
						Mixpanel.track('view_event_payment_successful', {
							event_action: 'viewed',
							event_name: calendarItem?.title,
							event_start_date: calendarItem?.display_date,
							userId: user?.uid || userData?.uid,
							event_page: 'event_payment_page',
						});
					} catch (e) {}
				} else {
					setState(STATES.PAYMENT_FAILURE_PAGE);
					toast.error(
						`Your payment of ${parsedPrice} has been failed due to some technical reasons.`,
						{
							position: toast.POSITION.TOP_CENTER,
							autoClose: 2000,
							hideProgressBar: true,
						}
					);

					try {
						Mixpanel.track('view_event_payment_failed', {
							event_action: 'viewed',
							event_start_date: calendarItem?.display_date,
							phone: userData?.phoneNumber || userData?.phone,
							event_page: 'event_payment_page',
						});
					} catch (e) {}
				}
			},
			prefill: {
				name: user?.name || userData?.name,
				contact:
					user?.phoneNumber ||
					user?.phone ||
					userData?.phoneNumber ||
					userData?.phone ||
					'9959637700',
				email: user?.email || userData?.email || 'contact@seekapp.co',
			},
			theme: { color: COLORS.PRIMARY },
			modal: {
				ondismiss: function (response: any) {
					try {
						Mixpanel.track('view_event_payment_failed', {
							event_action: 'viewed',
							event_start_date: calendarItem?.display_date,
							phone: userData?.phoneNumber || userData?.phone,
							event_page: 'event_payment_page',
						});
					} catch (e) {}

					toast.error(
						`Your payment of ${parsedPrice} has been failed due to some technical reasons.`,
						{
							position: toast.POSITION.TOP_CENTER,
							autoClose: 2000,
							hideProgressBar: true,
						}
					);
				},
			},
		};

		const paymentObject = (window as any).Razorpay(options);
		paymentObject.open();
	}

	const onJoinWhatsAppsCommunityHandler = async () => {
		try {
			let whatsappGroupLink =
				'https://chat.whatsapp.com/DjjW2D53bOsK8aZ7YpAFZI';
			Mixpanel.track('click_join_whatsapp_event_group', {
				event_action: 'clicked',
				context_user_id: user?.uid,
				event_name: calendarItem?.title,
				phone: userData?.phoneNumber || userData?.phone,
			});
			window.open(calendarItem?.whatsapp_link || whatsappGroupLink, '_blank');
			setTimeout(() => {
				if (user?.source === 'WEB') {
					navigate('/home');
				}
			}, 1000);
		} catch (error) {
			console.error(error);
		}
	};

	useEffect(() => {
		Mixpanel.startRecording();

		return () => Mixpanel.stopRecording();
	}, []);

	const proceedFromCourseDescriptionPage = async () => {
		Mixpanel.track('click_to_register_event', {
			event_action: 'clicked',
			event_page: 'event_landing_page',
			event_start_date: calendarItem?.display_date,
			event_name: calendarItem?.title,
		});

		if (currentDateMoment.isAfter(formattedDateTime)) {
			// Course already started
			return;
		}

		if (!isEmpty(user) || userData) {
			setState(STATES.COURSE_CHECKOUT_PAGE);
		} else {
			Mixpanel.track('view_register_with_seek', {
				event_action: 'viewed',
				event_page: 'register_with_seek',
				event_name: calendarItem?.title,
			});
			setState(STATES.COURSE_SIGNUP_FORM);
		}
	};

	useEffect(() => {
		Mixpanel.startRecording();

		return () => Mixpanel.stopRecording();
	}, []);

	const onFAQClickHandler = (index: number) => {
		if (selectedFAQIndex !== index) {
			try {
				Mixpanel.track('click_event_landing_page_faqs', {
					event_action: 'clicked',
					faq_heading: FaqsCourse[index].q,
					event_page: events_page.event_landing_page,
				});
			} catch (e) {}
		}
		setSelectedFAQIndex((prevState) => (prevState === index ? null : index));
	};

	const onBackArrowClick = () => {
		if (state === STATES.COURSE_DESCRIPTION_PAGE) {
			if (!userData || isEmpty(user)) {
				window.location.href = 'https://seekdaily.live';
				navigate('/');
			} else {
				navigate('/courses');
			}
		}

		setState((prevState) => {
			switch (prevState) {
				case STATES.COURSE_CHECKOUT_PAGE:
					return STATES.COURSE_DESCRIPTION_PAGE;
				case STATES.COURSE_SIGNUP_FORM:
					return STATES.COURSE_DESCRIPTION_PAGE;
				case STATES.COURSE_OTP_FORM:
					return STATES.COURSE_SIGNUP_FORM;
				default:
					return prevState;
			}
		});
	};

	const onFormSubmitHandler = async (fullName: string, phoneNumber: string) => {
		const checkUserExistOrNotResponse = await checkUserExistOrNot(
			phoneNumber,
			'COURSE'
		);
		if (
			checkUserExistOrNotResponse?.status === 409 &&
			checkUserExistOrNotResponse?.message ===
				'User already exists. Show otp screen'
		) {
			// login user directly without otp
			try {
				const userLoginResult = await loginInternationalUsers(phoneNumber);
				console.log('loginInternationalUsers', userLoginResult);
				if (userLoginResult?.status === 200) {
					console.log('login successful if', userLoginResult.userData?.uid);
					Mixpanel.identify(userLoginResult.userData?.uid);
					Mixpanel.track(events.view_login_successful, {
						event_page: events_page.sign_up,
						event_action: events_action.viewed,
						response: {
							phone: phoneNumber,
						},
					});
					const user = {
						phone: userLoginResult?.userData?.phone,
						name: userLoginResult?.userData?.name,
						phoneNumber: userLoginResult?.userData?.phoneNumber,
						uid: userLoginResult.userData?.uid,
						// isProfileCompleted: isProfileCompleted,
					};

					dispatch(addUsers(userLoginResult.userData));
					window.localStorage.setItem('user', JSON.stringify(user));
					setState(STATES.COURSE_CHECKOUT_PAGE);
					// setLoader(false);
				} else {
					// setLoader(false);
					console.log('login successful else');
					setError('Please enter the correct OTP');
					Mixpanel.track('otp_incorrect', {
						event_page: events_page.otp_screen,
						event_action: events_action.viewed,
					});
				}
			} catch (e) {}
		} else {
			// signup user directly without otp.
			const nameArray = fullName.split(' ');
			const firstName = nameArray[0];
			const lastName = nameArray.slice(1).join(' ');

			const formDataMergedFromFirebaseAndSingUpForm = {
				userPartOfWhatsappCommunity: false,
				name: fullName,
				phone: phoneNumber,
				source: 'WEB',
				experiment_keys: {
					plan_experiment_key,
					onboarding_experiment_key,
					subscription_experiment_key,
				},
				trialStartDate: moment().format('D MMM YYYY'),
			};
			try {
				const userSignUpResult = await signUpUser(
					formDataMergedFromFirebaseAndSingUpForm,
					'COURSE'
				);
				if (
					userSignUpResult.status === 201 ||
					userSignUpResult.status === 200
				) {
					setLoader(false);
					Mixpanel.identify(userSignUpResult.userId);
					Mixpanel.people.set({
						$id: userSignUpResult.userId,
						$first_name: firstName,
						$last_name: lastName,
						$plan_experiment_key: plan_experiment_key,
						$onboarding_experiment_key: onboarding_experiment_key,
						$name: fullName,
						$phone: phoneNumber,
					});
					setLoader(false);
					Mixpanel.track('SignUp', userSignUpResult.userData);
					window.localStorage.setItem(
						'user',
						JSON.stringify(userSignUpResult.userData)
					);
					dispatch(addUsers(userSignUpResult.userData));
					setState(STATES.COURSE_CHECKOUT_PAGE);
				} else {
					setLoader(false);
				}
			} catch (e) {}
		}
	};

	const chatWhatsAppsHandler = async (sticker: boolean) => {
		const defaultMessage = `Hi, I would like to know more about this event - ${calendarItem?.title}`;

		try {
			const event_name = sticker ? 'click_whatsapp_chat' : 'click_talk_to_us';
			Mixpanel.track(event_name, {
				event_action: 'clicked',
				event_name: calendarItem?.title,
				event_page: events_page.event_landing_page,
			});

			const phoneNumber = '9555434844'; // No "+" or spaces
			const encodedMessage = encodeURIComponent(defaultMessage);
			const whatsappGroupLink = `https://wa.me/${phoneNumber}?text=${encodedMessage}`;

			window.open(whatsappGroupLink, '_blank');
		} catch (error) {
			console.error('Error:', error);
		}
	};

	const thumbnailRef = useRef<any>();
	const introRef = useRef<any>();

	useEffect(() => {
		if (introRef.current)
			introRef.current.setAttribute(
				'controlsList',
				'nodownload noremoteplayback noplaybackrate'
			);
	}, [introRef]);

	if (loader) {
		return <Loader />;
	} else if (state === STATES.PAYMENT_SUCCESS_PAGE) {
		return calendarItem?.title ? (
			<div
				style={{
					display: 'flex',
					flexDirection: 'column',
					justifyContent: 'center',
					alignItems: 'center',
					marginTop: '154px',
					position: 'relative',
				}}>
				<PaymentSuccess width={120} height={120} />
				<span className={'course-payment-success-hurray'}>
					Payment Successful 🎉
				</span>
				<span className={'course-payment-success-plan-description'}>
					{`You have successfully enrolled in `}
					<strong
						style={{
							color: '#2A2A2A',
							fontWeight: '500',
							fontFamily: 'Poppins-Medium',
						}}>
						{calendarItem?.title}
					</strong>
					{`. We will share further details with you over WhatsApp.`}
				</span>
				<PrimaryButton
					isSticky={false}
					style={{
						alignSelf: 'center',
						width: 'auto',
						height: '40px',
						marginTop: '24px',
						borderRadius: '8px',
						background:
							'var(--Primary-Gradient, linear-gradient(106deg, #4462EF 32.65%, #1B3DD8 105.18%))',
					}}
					onClick={onJoinWhatsAppsCommunityHandler}>
					Join WhatsApp Group
				</PrimaryButton>
			</div>
		) : (
			<></>
		);
	} else if (state === STATES.PAYMENT_FAILURE_PAGE) {
		return calendarItem?.price ? (
			<div
				style={{
					display: 'flex',
					flexDirection: 'column',
					justifyContent: 'center',
					alignItems: 'center',
					marginTop: '50%',
					position: 'relative',
				}}>
				<svg
					xmlns='http://www.w3.org/2000/svg'
					width='98'
					height='88'
					viewBox='0 0 98 88'
					fill='none'>
					<path
						d='M40.5607 5.27521C41.4261 3.80618 42.6599 2.58845 44.1402 1.74244C45.6204 0.896423 47.2959 0.451416 49.0009 0.451416C50.7059 0.451416 52.3813 0.896423 53.8616 1.74244C55.3419 2.58845 56.5757 3.80618 57.4411 5.27521L77.0745 38.9413L96.7087 72.6026C97.5586 74.0753 98.004 75.7466 98 77.447C97.9959 79.1473 97.5426 80.8164 96.6858 82.2851C95.829 83.7539 94.5992 84.9701 93.121 85.8105C91.6429 86.6509 89.9688 87.0857 88.2685 87.0708H9.73245C8.0319 87.0859 6.35759 86.6511 4.8792 85.8106C3.4008 84.9701 2.17086 83.7537 1.31401 82.2848C0.457158 80.8158 0.00385102 79.1464 2.4429e-05 77.4458C-0.00380216 75.7452 0.441987 74.0738 1.29222 72.6009L20.9264 38.9413L40.5607 5.27521Z'
						fill='#FD2727'
					/>
					<path
						d='M45.503 53.5448L44.4848 38.462C44.2941 35.523 44.1988 33.4134 44.1988 32.1333C44.1092 30.6455 44.6058 29.1818 45.5822 28.0557C46.0511 27.5676 46.6183 27.1846 47.2463 26.9322C47.8743 26.6798 48.5487 26.5636 49.225 26.5914C51.0489 26.5914 52.2683 27.216 52.8834 28.4651C53.5845 30.1755 53.8995 32.0195 53.8059 33.8656C53.8043 35.2751 53.7299 36.6835 53.5828 38.0853L52.2149 53.6109C52.1571 55.0735 51.8337 56.5133 51.2605 57.8601C51.0544 58.3223 50.713 58.7113 50.2814 58.9755C49.8497 59.2397 49.348 59.3667 48.8426 59.3399C48.3455 59.3775 47.8491 59.2598 47.4217 59.0033C46.9943 58.7467 46.6571 58.3638 46.4565 57.9075C45.9094 56.5135 45.5873 55.0415 45.5021 53.5464L45.503 53.5448ZM49.033 74.2649C47.7889 74.2831 46.582 73.84 45.6451 73.0213C45.1579 72.5874 44.7747 72.0493 44.5241 71.4469C44.2736 70.8445 44.1621 70.1933 44.198 69.5419C44.1877 68.9228 44.3052 68.3083 44.5432 67.7368C44.7813 67.1652 45.1347 66.6489 45.5814 66.2202C46.0237 65.7742 46.5522 65.4227 47.1346 65.1873C47.717 64.9519 48.3412 64.8373 48.9693 64.8507C49.6018 64.8392 50.2303 64.9544 50.8176 65.1896C51.4049 65.4248 51.9392 65.7752 52.389 66.2202C52.8438 66.6443 53.2047 67.159 53.4485 67.7311C53.6923 68.3032 53.8135 68.9201 53.8043 69.5419C53.8373 70.1893 53.7259 70.8359 53.4783 71.435C53.2307 72.034 52.8531 72.5706 52.3727 73.0058C51.457 73.8304 50.2643 74.2799 49.0322 74.2649'
						fill='white'
					/>
				</svg>
				<span
					style={{
						color: '#3A3A3A',
						textAlign: 'center',
						fontFamily: 'Poppins-SemiBold',
						fontSize: '24px',
						fontStyle: 'normal',
						fontWeight: 600,
						lineHeight: 'normal',
						marginTop: '32px',
					}}>
					Payment Failed
				</span>
				<span
					className={'payment-success-plan-description'}
					style={{
						marginTop: '16px',
					}}>{`Your payment of ${calendarItem?.currency}${calendarItem?.price} has been failed due to some technical reasons.`}</span>

				<CLose
					onClick={navigate.bind(null, -1)}
					style={{ position: 'absolute', top: -120, right: 24 }}
					width={36}
					height={36}
				/>

				<Button
					isSticky={false}
					style={{
						alignSelf: 'center',
						background:
							'var(--primary_lr_grad, linear-gradient(106deg, #534DE0 32.65%, #4641A8 105.18%))',
					}}
					onClick={payNowClickHandler.bind(
						null,
						calendarItem?.price,
						appliedKarmaPoints,
						recordingStatus
					)}
					label={'Retry Payment'}
				/>
			</div>
		) : (
			<></>
		);
	} else if (state === STATES.COURSE_CHECKOUT_PAGE) {
		return (
			<EventCheckoutPage
				imageUrl={imageUrl}
				userId={user?.uid || userData?.uid}
				totalKarma={user?.total_karma}
				courseItem={calendarItem}
				recordingStatus={recordingStatus}
				setRecordingStatus={setRecordingStatus}
				payNowClickHandler={payNowClickHandler}
				onBackArrowClick={onBackArrowClick}
			/>
		);
	} else if (state === STATES.COURSE_SIGNUP_FORM) {
		return (
			<GreyAppLayout>
				<CourseRegistraionForm
					loading={loader}
					onFormSubmitHandler={onFormSubmitHandler}
					setState={setState}
					onBackArrowClick={onBackArrowClick}
					user={user}
					phone={detailsPhone}
					name={name}
					course_name={calendarItem?.title}
				/>
			</GreyAppLayout>
		);
	}

	const handleVideoClick = () => {
		if (isPlayingTopVideo) {
			if (!isIOS) {
				introRef.current.pause();
				setIsPlayingTopVideo(false);
			}
		} else {
			introRef.current.play();
			setIsPlayingTopVideo(true);
			setIsVideoPlayedOnce(true);
		}
	};

	return (
		<>
			<div className='course-description-container dark'>
				<div
					style={{
						width: '100%',
						maxWidth: '400px',
						position: 'fixed',
						top: '0',
						zIndex: 1000000,
						background: '#1b1625',
					}}>
					<div
						style={{ width: '100%', padding: '16px 27px', margin: '0 auto' }}>
						<BackButton isDark onClick={navigate.bind(null, -1)} />
					</div>
					{calendarItem?.comment &&
						!currentDateMoment.isAfter(formattedDateTime) && (
							<div
								style={{
									width: '100%',
									padding: '4px 8px',
									display: 'flex',
									gap: '8px',
									backgroundColor: '#383838',
								}}>
								<img
									style={{ width: '16px', height: '16px' }}
									src={eventTicketIcon}
									alt=''
								/>
								<p
									style={{
										marginBottom: '0',
										fontSize: '12px',
										fontFamily: 'Gordita-Medium',
										color: '#ffffff',
									}}>
									{calendarItem?.comment}
								</p>
							</div>
						)}
				</div>

				<div
					style={{
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center',
						alignSelf: 'center',
						width: '100%',
						borderRadius: '12px',
						maxWidth: '343px',
						marginTop:
							calendarItem?.comment &&
							!currentDateMoment.isAfter(formattedDateTime)
								? '120px'
								: '74px',
						position: 'relative',
						marginBottom: '12px',
					}}>
					{!isIOS && videoUrl ? (
						muted ? (
							<Mute
								onClick={() => setMuted(false)}
								width={20}
								height={20}
								style={{
									position: 'absolute',
									top: '8px',
									left: '8px',
									color: 'white',
									zIndex: '2',
								}}
							/>
						) : (
							<UnMute
								onClick={() => setMuted(true)}
								width={20}
								height={20}
								style={{
									position: 'absolute',
									top: '8px',
									left: '8px',
									color: 'white',
									zIndex: '2',
								}}
							/>
						)
					) : (
						<></>
					)}

					<Shimmer style={{ height: '192.5px', opacity: '0' }} />

					{!!videoUrl && (
						<video
							ref={introRef}
							controls
							onClick={handleVideoClick}
							onLoadedData={() => setVideoLoaded(true)}
							autoPlay={false}
							loop={true}
							src={videoUrl}
							playsInline
							muted={muted}
							style={{
								width: '100%',
								display: 'block',
							}}></video>
					)}
					{!!imageUrl && !isPlayingTopVideo && !isVideoPlayedOnce && (
						<img
							src={imageUrl}
							ref={thumbnailRef}
							alt=''
							style={{
								position: 'absolute',
								zIndex: 9999,
							}}
							className={'course-description-image-banner'}
						/>
					)}

					{!!videoUrl && !isPlayingTopVideo && !isVideoPlayedOnce && (
						<img
							onClick={handleVideoClick}
							src={watchIntro}
							style={{
								position: 'absolute',
								zIndex: 9999,
							}}
							alt=''
						/>
					)}
				</div>

				<div
					style={{
						display: 'flex',
						flexDirection: 'column',
						alignItems: 'start',
						width: '344px',
						marginTop: '24px',
						alignSelf: 'center',
						justifyContent: 'space-between',
					}}>
					<div
						style={{
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'space-between',
							width: '100%',
						}}>
						<span
							style={{
								color: '#ffffff',
								fontFamily: 'Gordita-Medium',
								fontSize: '20px',
								fontStyle: 'normal',
								fontWeight: 500,
								lineHeight: 'normal',
								marginRight: 'auto',
								display: 'inline',
							}}>
							{calendarItem?.title}
						</span>
					</div>

					<div
						style={{ marginTop: '16px', marginBottom: '8px' }}
						className='course-cover-info-date'>
						<img src={calenderIcon} alt='' />
						<p>{calendarItem?.display_date}</p>
					</div>
					<div
						style={{ width: '100%', marginBottom: '0' }}
						className='course-cover-info-details'>
						<div className='course-cover-info-details-item'>
							<img
								style={{
									margin: '-4px 0 0 0',
								}}
								src={liveIcon}
								alt=''
							/>
							<p>{calendarItem?.time_slot[0]?.slot}</p>
						</div>
						<div className='course-cover-info-details-divider'></div>
						<div className='course-cover-info-details-item'>
							<img src={durationIcon} alt='' />
							<p>{calendarItem?.duration}</p>
						</div>
						<div className='course-cover-info-details-divider'></div>
						<div className='course-cover-info-details-item'>
							<img src={languageIcon} alt='' />
							<p>{calendarItem?.language}</p>
						</div>
					</div>

					<div
						ref={lightRef}
						style={{
							width: '402px',
							marginTop: !calendarItem?.refund_available ? '16px' : '0px',
							position: 'relative',
							left: '-29px',
							paddingLeft: '29px',
							borderRadius: '12px 12px 0 0',
						}}>
						<div ref={courseSliderRef} className='course-slider-container'>
							<Swiper
								ref={swiperRef}
								className='course-slider'
								freeMode={true}
								slidesPerView={'auto'}
								slidesOffsetAfter={0}
								spaceBetween={20}
								modules={[FreeMode]}>
								{eventsTabs.map((tab, index) => {
									return (
										<SwiperSlide key={index}>
											<div
												onClick={() => {
													swiperRef.current?.swiper.slideTo(index);
													if (tabRefs.current[index].current) {
														tabRefs.current[index].current!.scrollIntoView();
													}
													setSelectedTab(index);
													Mixpanel.track('click_navigation_bar', {
														event_page: events_page.event_landing_page,
														event_action: 'viewed',
														navigate_on: eventsTabs[index],
													});
												}}
												className={`course-slider-tab ${
													selectedTab === index && 'active'
												}`}>
												<p className='course-slider-tab-title'>{tab}</p>
											</div>
										</SwiperSlide>
									);
								})}
							</Swiper>
						</div>
						<div style={{ marginTop: '68px' }}>
							{calendarItem?.whats_included &&
							calendarItem?.whats_included.length ? (
								<>
									<div
										className='page-section-title-scroll'
										ref={tabRefs.current[0]}></div>
									<div className={'course-page-section-title'}>
										About
										<div
											style={{
												height: '1px',
												background:
													'linear-gradient(to right, #a4a4a4, transparent)',
												width: '200px',
												marginLeft: '8px',
											}}></div>
									</div>
									<p
										style={{
											color: '#eeeeee',
											fontFamily: 'Gordita-Regular',
											fontSize: '14px',
											width: '343px',
											fontWeight: 400,
											marginTop: '8px',
											lineHeight: '24px',
										}}>
										{calendarItem?.about}
									</p>
									<div
										className='page-section-title-scroll'
										ref={tabRefs.current[1]}></div>
									<div className={'course-page-section-title'}>
										What you get
										<div
											style={{
												height: '1px',
												background:
													'linear-gradient(to right, #a4a4a4, transparent)',
												width: '200px',
												marginLeft: '8px',
											}}></div>
									</div>
									<div
										style={{ width: '344px', marginTop: '12px' }}
										className='course-what-you-get'>
										{calendarItem?.whats_included.map(
											(item: any, index: number) => {
												return (
													<CourseWhatYouGetItem
														key={index}
														item={{
															icon: item.icon,
															subtitle: item.description,
														}}
														event={true}
														divider={
															index !== calendarItem?.whats_included.length - 1
														}
													/>
												);
											}
										)}
									</div>
								</>
							) : (
								<></>
							)}
							<div
								className='page-section-title-scroll'
								ref={tabRefs.current[2]}></div>
							{!!calendarItem?.why_to_join && (
								<>
									<div className={'course-page-section-title'}>
										Why to join
										<div
											style={{
												height: '1px',
												background:
													'linear-gradient(to right, #a4a4a4, transparent)',
												width: '150px',
												marginLeft: '8px',
											}}></div>
									</div>
									<CourseBenefits
										benefits={calendarItem?.why_to_join.map((item: any) => {
											return { icon: item.icon, title: item.description };
										})}
									/>
								</>
							)}
							<div
								className='page-section-title-scroll'
								ref={tabRefs.current[3]}></div>
							{!!calendarItem?.ideal_for && (
								<>
									<div className={'course-page-section-title'}>
										Ideal for
										<div
											style={{
												height: '1px',
												background:
													'linear-gradient(to right, #a4a4a4, transparent)',
												width: '150px',
												marginLeft: '8px',
											}}></div>
									</div>
									<div style={{ width: '343px', marginTop: '12px' }}>
										{calendarItem?.ideal_for.map(
											(item: string, index: number) => {
												return (
													<div
														style={{
															display: 'flex',
															gap: '8px',
															marginTop: '12px',
															alignItems: 'start',
														}}>
														<img
															style={{ width: '20px' }}
															src={bullet}
															alt=''
														/>
														<p
															style={{
																color: '#eeeeee',
																fontFamily: 'Gordita-Regular',
																fontSize: '14px',
																marginBottom: 0,
															}}>
															{item}
														</p>
													</div>
												);
											}
										)}
									</div>
								</>
							)}
						</div>
						<div
							className='page-section-title-scroll'
							ref={tabRefs.current[4]}></div>
						<div className={'course-page-section-title'}>
							Know Your Instructors
							<div
								style={{
									height: '1px',
									background: 'linear-gradient(to right, #a4a4a4, transparent)',
									width: '200px',
									marginLeft: '8px',
								}}></div>
						</div>
						{calendarItem && calendarItem?.instructors ? (
							calendarItem?.instructors?.map(
								(instructor: any, index: number) => {
									return (
										<>
											<KnowYourInstructor dark instructorData={instructor} />
											{index !== calendarItem?.instructors?.length - 1 &&
												calendarItem?.instructors?.length > 1 && (
													<div
														style={{
															height: '1px',
															borderBottom: '1px dashed rgb(214, 214, 214)',
															width: '344px',
															marginBottom: '12px',
														}}></div>
												)}
										</>
									);
								}
							)
						) : (
							<></>
						)}
						<span
							className='page-section-title-scroll'
							ref={tabRefs.current[5]}></span>
						<div className={'course-page-section-title'}>
							FAQs
							<div
								style={{
									height: '1px',
									background: 'linear-gradient(to right, #a4a4a4, transparent)',
									width: '200px',
									marginLeft: '8px',
								}}></div>
						</div>
						<div style={{ width: '344px' }}>
							{calendarItem?.FAQs?.map((faq: any, index: any) => (
								<FAQ
									key={index}
									dark
									selectedIndex={selectedFAQIndex}
									index={index}
									item={faq}
									onClickHandler={onFAQClickHandler}
								/>
							))}
						</div>
						<div onClick={() => chatWhatsAppsHandler(false)}>
							<img
								ref={whatsappRef}
								className='course-whatsapp-bottom'
								src={whatsappBar}
								alt=''
							/>
						</div>
						<Support
							ref={supportRef}
							onClick={() => chatWhatsAppsHandler(true)}
							style={{
								position: 'fixed',
								alignSelf: 'center',
								bottom: '84px',
								right: '2px',
								zIndex: '10000000001',
								cursor: 'pointer',
								backgroundColor: 'transparent',
							}}
							width={64}
							height={64}
						/>
					</div>

					<div
						style={{ backgroundColor: '#232323' }}
						className='plan-fixed-bottom-container'>
						<div style={{ display: 'flex', flexDirection: 'column' }}>
							<span
								style={{ color: '#ffffff' }}
								className='plan-fixed-bottom-price'>{`${
								calendarItem?.currency
							}${Number(calendarItem?.price)}`}</span>
						</div>
						<button
							disabled={
								calendarItem?.user_already_registered ||
								currentDateMoment.isAfter(formattedDateTime)
							}
							className='plan-fixed-bottom-button'
							style={{
								background:
									calendarItem?.user_already_registered ||
									(currentDateMoment.isAfter(formattedDateTime) && '#A4A4A4'),
							}}
							onClick={proceedFromCourseDescriptionPage}>
							{currentDateMoment.isAfter(formattedDateTime)
								? 'Registration closed'
								: calendarItem?.user_already_registered
								? 'Already registered'
								: 'Register Now'}
						</button>
					</div>
				</div>
			</div>
		</>
	);
};

export default UpcomingEventDescriptionPage;
